import React from 'react';

const GPExtensionResultToast = ({
  markedGreenCount = 0,
  skippedCount = 0,
  markedGreen = [],
  skipped = [],
  studentsList = [],
  message = ''
}) => {
  const getStudentInfo = (studentId, uid) => {
    if (!Array.isArray(studentsList)) return {};
    return (
      studentsList.find((st) => {
        const sId =
          st.id ||
          st._id ||
          st.studentId ||
          st.userId ||
          st.student?._id ||
          st.student?.id ||
          st.student?.studentId;
        const sUid = st.UID || st.uid || st.student?.UID || st.student?.uid;
        if (studentId && sId && String(sId) === String(studentId)) return true;
        if (uid && sUid && String(sUid).toLowerCase() === String(uid).toLowerCase()) return true;
        return false;
      }) || {}
    );
  };

  const rows = [];

  // 1. Process Red Flag Removed entries
  if (Array.isArray(markedGreen)) {
    markedGreen.forEach((item) => {
      const isObj = item && typeof item === 'object';
      const studentId = isObj ? item.studentId || item.id : item;
      const uid = isObj ? item.uid : null;
      const directName =
        isObj && typeof item.name === 'string' && item.name.trim()
          ? item.name.trim()
          : null;
      const st = directName ? {} : getStudentInfo(studentId, uid);
      rows.push({
        studentId,
        uid: uid || st.UID || st.uid || 'N/A',
        name:
          directName ||
          st.studentFullName ||
          st.fullName ||
          st.studentName ||
          st.name ||
          (st.firstName ? `${st.firstName} ${st.lastName || ''}`.trim() : '') ||
          'N/A',
        status: 'Red Flag Removed',
        reason: (isObj && item.reason ? String(item.reason).replace(/marked green/gi, 'red flag removed') : null) || 'Red flag removed successfully'
      });
    });
  }

  // 2. Process Skipped entries
  if (Array.isArray(skipped)) {
    skipped.forEach((item) => {
      const isObj = item && typeof item === 'object';
      const studentId = isObj ? item.studentId || item.id : item;
      const uid = isObj ? item.uid : null;
      const directName =
        isObj && typeof item.name === 'string' && item.name.trim()
          ? item.name.trim()
          : null;
      const st = directName ? {} : getStudentInfo(studentId, uid);
      rows.push({
        studentId,
        uid: uid || st.UID || st.uid || 'N/A',
        name:
          directName ||
          st.studentFullName ||
          st.fullName ||
          st.studentName ||
          st.name ||
          (st.firstName ? `${st.firstName} ${st.lastName || ''}`.trim() : '') ||
          'N/A',
        status: 'Skipped',
        reason: (isObj && item.reason) || 'No punch found in window'
      });
    });
  }

  const totalMarked =
    typeof markedGreenCount === 'number'
      ? markedGreenCount
      : (Array.isArray(markedGreen) ? markedGreen.length : 0);

  const totalSkipped =
    typeof skippedCount === 'number'
      ? skippedCount
      : (Array.isArray(skipped) ? skipped.length : 0);

  const formattedMessage = message ? message.replace(/marked green/gi, 'red flag removed') : '';
  const headerTitle = formattedMessage
    ? formattedMessage.toLowerCase().includes('summary')
      ? formattedMessage
      : `GP Extension Summary: ${formattedMessage}`
    : `GP Extension Summary: ${totalMarked} red flag removed, ${totalSkipped} skipped`;

  const containerStyle = {
    width: 680,
    maxWidth: '95vw'
  };
  const boxStyle = {
    background: '#fff',
    borderRadius: 12,
    border: '1px solid #e5e7eb',
    overflow: 'hidden'
  };
  const headerStyle = {
    padding: '12px 16px',
    borderBottom: '1px solid #e5e7eb',
    fontWeight: 600,
    fontSize: 14,
    color: '#111827'
  };
  const tableHeadCell = {
    padding: '10px 12px',
    fontWeight: 600,
    color: '#374151',
    fontSize: 13,
    borderBottom: '1px solid #e5e7eb',
    background: '#f8fafc',
    textAlign: 'left',
    position: 'sticky',
    top: 0
  };
  const rowCellBase = {
    padding: '10px 12px',
    fontSize: 13,
    color: '#374151',
    borderBottom: '1px solid #f1f5f9',
    verticalAlign: 'top'
  };

  return (
    <div style={containerStyle}>
      <div style={boxStyle}>
        <div style={headerStyle}>{headerTitle}</div>
        <div style={{ maxHeight: 360, overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
            <colgroup>
              <col style={{ width: '10%' }} />
              <col style={{ width: '22%' }} />
              <col style={{ width: '24%' }} />
              <col style={{ width: '14%' }} />
              <col style={{ width: '30%' }} />
            </colgroup>
            <thead>
              <tr>
                <th style={tableHeadCell}>Row</th>
                <th style={tableHeadCell}>UID</th>
                <th style={tableHeadCell}>Name</th>
                <th style={tableHeadCell}>Status</th>
                <th style={tableHeadCell}>Reason</th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((r, idx) => {
                  const isSkipped = r.status === 'Skipped';
                  return (
                    <tr key={idx}>
                      <td style={{ ...rowCellBase, textAlign: 'center' }}>{idx + 1}</td>
                      <td style={{ ...rowCellBase, wordBreak: 'break-all' }}>{r.uid}</td>
                      <td
                        style={{
                          ...rowCellBase,
                          wordBreak: 'break-all'
                        }}
                      >
                        {r.name}
                      </td>
                      <td
                        style={{
                          ...rowCellBase,
                          fontWeight: 600,
                          color: isSkipped ? '#dc2626' : '#16a34a'
                        }}
                      >
                        {r.status}
                      </td>
                      <td
                        style={{
                          ...rowCellBase,
                          whiteSpace: 'normal',
                          wordBreak: 'break-word'
                        }}
                      >
                        {r.reason}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={5}
                    style={{ ...rowCellBase, textAlign: 'center', padding: '20px' }}
                  >
                    No log records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GPExtensionResultToast;
